/** Registration stats dto. */
export class RegistrationStatsDto {
  constructor(dto) {
    this.class = {
      assigned: dto.assigned,
      unassigned: dto.unassigned,
      total: dto.total,
    };
    this.elearning = {
      assigned: dto.assigned,
      unassigned: dto.unassigned,
      total: dto.total,
    };
    this.proctoru = {
      assigned: dto.assigned,
      unassigned: dto.unassigned,
      total: dto.total,
    };
  }
}
